import { color, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
export const ContentContainer = styled(Box) `
  box-sizing: border-box;
  background: ${color.background.input.default};
  padding: calc(${spacing.base.s} - 1px) ${spacing.base.m};
  border-radius: ${size.borderRadius};
  transition: border 0.3s ease;
  border: ${size.border.base.hairline} solid ${color.border.input.default};

  &:not(.focus) > * > .ScrollbarsCustom-Track {
    background-color: transparent;
  }

  &:hover {
    background-color: ${color.background.input.hovered};
    border-color: ${color.border.input.hovered};
    cursor: text;
  }

  &.focus,
  &:active {
    border: ${size.border.base.hairline} solid ${color.border.input.focused};
    background-color: ${color.background.input.focused};
  }

  &.disabled {
    background-color: ${color.background.input.disabled};
    color: ${color.background.disabled};
    border: ${size.border.base.hairline} solid ${color.base.transparent};
    cursor: not-allowed;

    & > * > .ScrollbarsCustom-Track {
      background-color: ${color.background.darker};
    }
  }

  &.hasError:not(.focus) {
    background-color: ${color.background.input.error};
    border: ${size.border.base.hairline} solid ${color.status.error.default};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RleHRBcmVhL3N0eWxlZC9Db250ZW50Q29udGFpbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDTCxLQUFLLEVBQ0wsSUFBSSxFQUNKLE9BQU8sR0FDUixNQUFNLGdEQUFnRCxDQUFDO0FBQ3hELE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFFaEMsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBOztnQkFFM0IsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsT0FBTztrQkFDNUIsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDLFdBQVcsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO21CQUN0QyxJQUFJLENBQUMsWUFBWTs7WUFFeEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxVQUFVLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLE9BQU87Ozs7Ozs7d0JBT2pELEtBQUssQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLE9BQU87b0JBQ2xDLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLE9BQU87Ozs7OztjQU1oQyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRLFVBQVUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsT0FBTzt3QkFDbkQsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsT0FBTzs7Ozt3QkFJOUIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsUUFBUTthQUMxQyxLQUFLLENBQUMsVUFBVSxDQUFDLFFBQVE7Y0FDeEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxVQUFVLEtBQUssQ0FBQyxJQUFJLENBQUMsV0FBVzs7OzswQkFJN0MsS0FBSyxDQUFDLFVBQVUsQ0FBQyxNQUFNOzs7Ozt3QkFLekIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsS0FBSztjQUN0QyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRLFVBQVUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsT0FBTzs7Q0FFMUUsQ0FBQyJ9